"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Button_1 = __importDefault(require("../../../Button/Button"));
var localization_1 = require("@scuf/localization");
function Footer(props) {
    var goToToday = props.goToToday, range = props.range, t = props.t, ok = props.ok, cancel = props.cancel, reset = props.reset, to = props.to, from = props.from, closeOnSelection = props.closeOnSelection, viewType = props.viewType, i18nShowToday = props.i18nShowToday, i18nOk = props.i18nOk, i18nCancel = props.i18nCancel, i18nClear = props.i18nClear;
    var buttonProps = viewType === 'compact' ? { size: 'small' } : {};
    var completed = to && from;
    return (React.createElement("div", { className: "date-picker-footer" },
        viewType === 'standard' && (React.createElement("div", { className: "today-btn", onClick: goToToday }, i18nShowToday !== null && i18nShowToday !== void 0 ? i18nShowToday : t('Show Today'))),
        (range || viewType === 'compact') && (React.createElement("div", { className: "button-wrap" },
            completed ? (React.createElement(Button_1.default, __assign({ type: "inline-secondary" }, buttonProps, { content: i18nClear !== null && i18nClear !== void 0 ? i18nClear : t('Clear'), onClick: reset }))) : (React.createElement(Button_1.default, __assign({ type: "inline-secondary" }, buttonProps, { content: i18nCancel !== null && i18nCancel !== void 0 ? i18nCancel : t('Cancel'), onClick: cancel }))),
            !closeOnSelection && React.createElement(Button_1.default, __assign({ type: "inline" }, buttonProps, { content: i18nOk !== null && i18nOk !== void 0 ? i18nOk : t('Ok'), onClick: ok, disabled: !completed }))))));
}
exports.default = localization_1.InjectLocalization(Footer);
